import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

const userStore = create(
    persist(
        (set, get) => ({
            user: null,
            setUser: (data) => set({ user: data }),
            logOut: () => set({
                user: null,
                tahunAnggaran: null
            }),
            reqCount: 0,
            tahunAnggaran: null,
            setTahunAnggaran: (data) => set({tahunAnggaran: data}),
            addReq: () => set({ reqCount: get().reqCount + 1 }),
        }),
        {
            name: 'AfhjvTdPFfbsdh',
            getStorage: () => createJSONStorage(() => localStorage),
        }
    )
)

export default userStore